export default __webpack_public_path__ + "static/media/bug.685753dc.svg";